import { ITranslations } from 'types/common';
import { BrandsRequestsTableTransFields } from './types';
import en from 'translations/en/brandsRequestsTable.json';
import pl from 'translations/pl/brandsRequestsTable.json';
import sl from 'translations/sl/brandsRequestsTable.json';

export const brandsRequestsTableTranslations: ITranslations<BrandsRequestsTableTransFields> = {
  name: 'brandsRequestsTable',
  en,
  pl,
  sl,
};
